import script from "./ReadingStreakWidget16464.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadingStreakWidget16464.vue?vue&type=script&setup=true&lang=ts"

import "./ReadingStreakWidget16464.vue?vue&type=style&index=0&id=6e2149b3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2149b3"]])

export default __exports__